export function initVideo() {
  const $cw = $(".cover-wrapper");

  if ($cw.length) {
    $cw.on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).fadeOut(300);
      $(this)
        .prev(".youtube-video")[0]
        .contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
    });
  }
}
